import { useEffect, useRef, useState } from "react";
import { Col, Card, Alert, notification, Button, Row } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import usePost from "../../../../hooks/usePost";

const initialAlertState = {
  type: "info",
  message:
    "El archivo CSV debe incluir: marca, región, CECO, año, semana,monto de faltantes ($), categoría del faltante, fecha (dd/mm/aaaa), estatus, código de faltante  (marca_ceco_Año_Semana_categoría_Monto), seguimiento analista(opcional).",
};

export default function CsvSelect(props) {
  const { setShowModal, onRefetch } = props;

  const [file, setFile] = useState({
    name: "",
    full: undefined,
  });
  const [alert] = useState(initialAlertState);

  const fileInputRef = useRef(null);

  const [api, contextHolder] = notification.useNotification();

  const { post, success, reset, error, loading } = usePost();

  const openNotificationWithIcon = (type, message, description = "") => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const handleFileChange = (event) => {
    const fileJs = event.target.files[0];

    if (fileJs) {
      const validCsvTypes = [
        "text/csv", // .csv
      ];

      if (validCsvTypes.includes(fileJs.type)) {
        openNotificationWithIcon("success", "Se ha agregado el archivo CSV");
        setFile({
          ...file,
          name: fileJs.name,
          full: fileJs,
        });
      } else {
        // Mostrar notificación si no es un archivo Excel
        openNotificationWithIcon(
          "warning",
          "Formato inválido",
          "Por favor, selecciona un archivo de tipo CSV."
        );
      }
    }
    // else {
    //   // Si no se seleccionó ningún archivo
    //   openNotificationWithIcon(
    //     "info",
    //     "No hay archivo",
    //     "No se seleccionó ningún archivo."
    //   );
    // }
  };

  const handleDeletFile = () => {
    setFile({
      ...file,
      name: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    reset();
  };

  const handleSubmitCsv = async () => {
    const formData = new FormData();

    formData.append("file", file.full);

    await post("faltante", formData, {
      "Content-Type": "multipart/form-data",
    });
  };

  useEffect(() => {
    if (success) {
      if (success) {
        openNotificationWithIcon("success", "Archivo subido correctamente");
        handleDeletFile();
        setShowModal(false);
        reset();
        onRefetch();
      } else {
        openNotificationWithIcon("error", "Error al subir el archivo");
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  useEffect(() => {
    if (error) {
      console.log("error", error);
      openNotificationWithIcon("error", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, success]);

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Abre el selector de archivos
  };

  return (
    <>
      {contextHolder}
      {file.name ? (
        <Row justify="center">
          <Card>
            <Col xs={24} md={24}>
              <div className="alert">
                Archivo seleccionado: {file.name}
                <DeleteOutlined className=" pl-5" onClick={handleDeletFile} />
              </div>
            </Col>
            <Col xs={24} md={24}>
              <Button
                onClick={handleSubmitCsv}
                type="primary"
                className="button-styles-add-element"
                disabled={loading || !file.full || error}
              >
                Enviar
              </Button>
            </Col>
          </Card>
        </Row>
      ) : (
        <>
          <Row
            justify="center"
            style={{
              marginBottom: "1em",
            }}
          >
            <Alert
              type={alert.type}
              message={alert.message}
              showIcon
              style={{
                width: "80%",
              }}
            />
          </Row>
          <Row justify="center">
            <Col xs={11} md={10} al>
              <input
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                style={{ display: "none" }}
                id="csv-upload"
                ref={fileInputRef}
              />
              {/* <label htmlFor="csv-upload" className="button-styles-add-element">
            Seleccionar CSV
          </label> */}
              <Button
                type="primary"
                className="button-styles-add-element"
                onClick={handleButtonClick}
              >
                Seleccionar CSV
              </Button>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}
